import React from 'react';

const Item = ({ item, getItemsLabel }) => /* @__PURE__ */ React.createElement(React.Fragment, null, getItemsLabel(item));

export { Item };
//# sourceMappingURL=Item.es.js.map
